module.exports = {
      id: "textsms-usage",
      viewBox: "0 0 28.57 28.57",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#textsms",
      toString: function () {
        return this.url;
      }
    }